// A one-sided style's own right-facing walk frames (owner, gate 4a, 2026-10-31): the game mirrors the left-facing rows
// to walk right, so the bob's clip swapped sides. scripts/anim/hair/families.py (RIGHT, mirror_id) writes them below the
// standing row: rows 6-8 walk right (side, front34, back34), row 9 their standing frames in the left ones' columns.
// Where a sheet has the right frame its layer draws that, unflipped; every other sheet is mirrored as before.
const RIGHT_ROW = { 0: 6, 3: 7, 4: 8 };
const COLS = 8;
const STAND = 40;
const STAND_R = 72;

/** The right-facing frame of a left-facing walk frame, or null where the game does not mirror (front, back). */
export function mirrorFrame(frame) {
  const f = Number(frame);
  const row = Math.floor(f / COLS);
  if (row in RIGHT_ROW) return RIGHT_ROW[row] * COLS + (f % COLS);
  if (f >= STAND && f < STAND + 5 && (f - STAND) in RIGHT_ROW) return STAND_R + f - STAND;
  return null;
}

/** {frame, flip} a layer draws for the body's `frame` and flip: its own right frame when `has` it, else the mirror. */
export function ownFrame(has, frame, flip) {
  if (!flip) return { frame, flip };
  const right = mirrorFrame(frame);
  return right !== null && has(String(right)) ? { frame: String(right), flip: false } : { frame, flip };
}
